import { render, staticRenderFns } from "./ScheduleCarousel.vue?vue&type=template&id=3a489d3e&scoped=true&"
import script from "./ScheduleCarousel.vue?vue&type=script&lang=js&"
export * from "./ScheduleCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleCarousel.vue?vue&type=style&index=0&id=3a489d3e&prod&lang=css&"
import style1 from "./ScheduleCarousel.vue?vue&type=style&index=1&id=3a489d3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a489d3e",
  null
  
)

export default component.exports